import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
// import ProgressBar from 'react-bootstrap/ProgressBar';
import TextLoop from 'react-text-loop';
import { connect } from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { bindActionCreators } from 'redux';
import footerIngenium from '../../../assets/images/ingiLOGO.png';
import {
  changeFaviconAndDocumentTitle,
  get,
  iosCaller,
  isIosApp,
  isWebView,
  setGlobalColors,
  useInterval,
} from '../../../Utilities';
import { getBranding, getColor, setComponent } from '../Login.service';
import './Preloader.scss';
import '../Login.scss';
import { getCurrentBranding } from '../../../redux/reducers/branding.reducer';
import ProgressBar from '../../Common/ProgressBar/ProgressBar';
import InitialsAvatar from './InitialsAvatar';
import { createTheme } from '@mui/material/styles';
import { getClientUserId } from '../../../redux/reducers/clientUserId.reducer';
import { clientUserIdActions } from '../../../redux/actions/clientUserId.action';

const Preloader = (props) => {
  const {
    fetchColors,
    fetchBranding,
    currentBranding,
    history,
    setComponentToStore,
    setAppLanguageObjectToStore,
    setAppLanguageToStore,
  } = props;
  const [count, setCount] = useState(0);
  const [showPoweredBy, setShowPoweredBy] = useState('false');
  const [image, setImage] = useState(footerIngenium);
  const [iosDeviceInfo, setIosDeviceInfo] = useState({});
  useInterval(() => {
    if (count >= 100) {
      return;
    }
    setCount((counter) => counter + 1);
  }, 20);

  useEffect(() => {
    setComponentToStore('PhoneNo');
    if (isWebView && typeof window.Android.disableSwipeRefresh !== 'undefined') {
      window.Android.disableSwipeRefresh();
    }
  }, []);

  const setClientColors = useCallback(
    (color = 'hsl(208, 96.4%, 56.7%)') => {
      const theme = createTheme({
        palette: {
          primary: {
            main: color, // your chosen color
          },
        },
      });
      const colorObject = theme.palette.primary;

      // Extract H, S, L values
      const init = color.indexOf('(');
      const fin = color.indexOf(')');
      const colorValues = color.substr(init + 1, fin - init - 1).split(',');

      const hue = parseFloat(colorValues[0]);
      const saturation = parseFloat(colorValues[1]);
      const lightness = parseFloat(colorValues[2]);

      // Existing lighter version (keep as-is)
      const lightSaturation = (parseFloat(colorValues[1]) * 0.6).toFixed(2);
      const lightcolorString = `hsl(${hue}, ${lightSaturation}%, 65%)`;

      // 🆕 Create lightest version (brighter + slightly less saturated)
      const lightestLightness = Math.min(lightness + 25, 95); // cap at 95%
      const lightestSaturation = Math.max(saturation * 0.7, 20); // slightly reduce saturation
      const lightestColorString = `hsl(${hue}, ${lightestSaturation}%, 91%)`;

      const superlightLightness = Math.min(lightness + 25, 95); // cap at 95%
      const superlightSaturation = Math.max(saturation * 0.7, 20); // slightly reduce saturation
      const superlightColorString = `hsl(${hue}, ${superlightSaturation}%, 97%)`;

      setGlobalColors(
        color,
        lightcolorString,
        lightestColorString,
        superlightColorString,
        colorObject,
      );

      const colorVariables = {
        primary: color,
        light: lightcolorString,
        lightest: lightestColorString,
        superlight: superlightColorString,
        materialLight: colorObject.light,
        materialDark: colorObject.dark,
        materialContrastText: colorObject.contrastText,
      };

      fetchColors(colorVariables);
    },
    [fetchColors],
  );

  const fetchLanguageObject = () => {
    get({ language_id: 1 }, '/getActivityText').then((res) => {
      if (res && res.success) {
        setAppLanguageObjectToStore(res.result);
        setAppLanguageToStore(1);
      }
    });
  };

  useEffect(() => {
    if (window.location.hostname === 'class.ingeniumedu.com') {
      window.location.href = 'https://portal.ingeniumedu.com/';
      return;
    }

    const baseDomain =
      process.env.NODE_ENV === 'development'
        ? 'testing.ingeniumedu.com'
        : window.location.hostname.replace('www.', '');

    const getIosDeviceInfo = (timeout = 800) =>
      new Promise((resolve) => {
        let resolved = false;

        const timer = setTimeout(() => {
          if (!resolved) {
            resolved = true;
            resolve({});
          }
        }, timeout);

        window.sendIosDeviceInfoToWeb = (jsonobject) => {
          if (resolved) return;

          resolved = true;
          clearTimeout(timer);

          try {
            resolve(jsonobject ? JSON.parse(jsonobject) : {});
          } catch (e) {
            resolve({});
          }
        };

        try {
          iosCaller('getDeviceInfo');
        } catch (e) {
          clearTimeout(timer);
          if (!resolved) {
            resolved = true;
            resolve({});
          }
        }
      });

    const run = async () => {
      let finalDomain = baseDomain;

      // if (isIosApp && baseDomain.includes('app.bhrigumarket.com')) {
      //   // code for ios release
      //   try {
      //     const deviceInfo = await getIosDeviceInfo(); // ✅ waits for the callback

      //     if (deviceInfo.appVersion === '1.0.2' && baseDomain.includes('app.bhrigumarket.com')) {
      //       finalDomain = 'getconnect.ingeniumedu.com';
      //     }
      //   } catch (err) {
      //     console.log('iOS device info failed');
      //   }
      // }

      fetchBranding({ domain_name: finalDomain });
      fetchLanguageObject();
    };

    run();
  }, [fetchBranding]);

  useEffect(() => {
    const { branding } = currentBranding;
    if (!currentBranding.pending) {
      setShowPoweredBy(branding.show_poweredby);
      setImage(branding.client_logo);
      if (branding.client_color) setClientColors(branding.client_color);
      else setClientColors();
      changeFaviconAndDocumentTitle(branding.client_icon, branding.client_name);
    }
  }, [currentBranding, setClientColors]);

  useEffect(() => {
    if (count === 100) {
      setTimeout(() => {
        setCount(0);

        // Read query params
        const searchParams = new URLSearchParams(history.location.search);
        const source = searchParams.get('source');

        if (isWebView) {
          history.replace('/login');
        } else if (isIosApp) {
          history.replace('/login');
        } else if (source === 'course') {
          history.replace('/login');
        } else {
          history.replace('/main');
        }
      }, 1000);
    }
  }, [count, history]);

  const hello = ['Hello', 'Dumantis', 'Bonjour', 'Namaskar'];

  return (
    <div className='text-center Login'>
      {/* <button onClick={() => history.push('/login')} style={{ position: 'fixed', top: '0px' }}>
        go
      </button> */}
      <div>
        {currentBranding.branding.client_logo ? (
          <LazyLoadImage
            src={image}
            alt='coachingLogo'
            style={{ background: 'transparent' }}
            className='Login__jumbo'
            // effect='blur'
          />
        ) : (
          <div className='w-100 d-flex justify-content-center'>
            <InitialsAvatar
              color={currentBranding.branding.client_color}
              name={currentBranding.branding.client_name}
              size='xl'
            />
          </div>
        )}
      </div>

      <div className='Preloader mx-auto'>
        <h1 className='Preloader__brand d-flex justify-content-center mx-lg-3 mt-lg-3 mb-lg-0 pt-lg-5 m-2 mt-5'>
          {currentBranding.branding.client_name}
        </h1>
        <p className='welcome-text mt-1 font'>{currentBranding.branding.client_tagline}</p>
      </div>
      <div className='preloadProgress'>
        <ProgressBar width={`${count}%`} height={'5px'} />
      </div>
      {/* {showPoweredBy === 'true' && (
        <footer className='py-4 Login__footer '>
          <h6 className='Login__footerText'>Powered By</h6>
          <img src={footerIngenium} alt='footerLogo' className='deskWidth' />
        </footer>
      )} */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentBranding: getCurrentBranding(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchBranding: getBranding,
      fetchColors: getColor,
      setComponentToStore: setComponent,
      setCLientUserIdToStore: clientUserIdActions.setCLientUserIdToStore,
      setUserIdToStore: clientUserIdActions.setUserIdToStore,
      setAppLanguageObjectToStore: clientUserIdActions.setAppLanguageObjectToStore,
      setAppLanguageToStore: clientUserIdActions.setAppLanguageToStore,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Preloader);

Preloader.propTypes = {
  fetchColors: PropTypes.func.isRequired,
  fetchBranding: PropTypes.func.isRequired,
  currentBranding: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};
